import {
  computed, observable, when, makeAutoObservable,
} from 'mobx';
import { AppStore } from '@gamiphy/loyalty-station-desktop/store/app';
import { UserStore } from '@gamiphy/loyalty-station-desktop/store/user';
import { PurchasesApi } from '@gamiphy/gamix-modules/purchases';
import { Purchase } from '@gamiphy/bl/purchases/types';
import { LevelStore } from '@gamiphy/loyalty-station-desktop/store/level';

class PurchaseStore {
    @observable purchases?: Purchase = undefined;

    constructor() {
      makeAutoObservable(this);

      when(() => AppStore.initialized, () => {
        void (async () => {
          this.purchases = await PurchasesApi.getPurchases();
        })();
      });
    }

    @computed get currentTierCash(): number {
      if (this.purchases && this.purchases.values && UserStore.user) {
        return Math.round((this.purchases.values.find((value) => value.tier === (UserStore.user?.tier))?.cash || 0) * 100);
      }
      return 0;
    }

    @computed get nextTierCash(): number {
      if (this.purchases && this.purchases.values && LevelStore.nextTier) {
        return Math.round((this.purchases.values.find((value) => value.tier === (LevelStore.nextTier?.order))?.cash || 0) * 100);
      }
      return 0;
    }

    getTierCash(tierOrder: number): number {
      return this.purchases?.values.find((t) => t.tier === tierOrder)?.cash ?? 0;
    }
}

export default new PurchaseStore();
